import moment from "moment/moment";
import {GET_OBJECT_SUCCESS} from "../../../../../apps/KpModule/actions/api";
import {getObjectMode} from "../../../../../apps/KpModule/selectors";
import {prepareListButton} from "../utils";
import {returnButton} from "../../utils";
import {setFieldEdition, setFieldVisibility} from "../../../../../apps/KpModule/actions";

const liberalityRecordPdfFields = [
    'id', 'applicationNumber', 'typeOfFile.code', 'administrator.fullName', 'benefactor',
    'grossAssets', 'assets', "netForecast", //'netAssets',
    'grossLiabilities', 'actsFees',
    'distribution.beneficiary.name', 'distribution.qualification.name', 'distribution.share', 'distribution.beneficiary.name',
    'status.id', 'fileApplicationNumberAndBenefactor',
    'assetsInfos.distribution.beneficiary.zipCodeAndName', 'assetsInfos.distribution.qualification.name', 'assetsInfos.distribution.confFor',
    'assetsInfos.distribution.beneficiaryShareInLiberalityRecordActsFees', 'assetInfos.estimatedAssetNetValue', 'assetInfos.estimatedAssetValue', 'assetInfos.assetLiabilities',
    'assetsInfos.distribution.share', 'assetsInfos.distribution.beneficiaryOwnLiabilities',
    'assetsInfos.distribution.estimatedBeneficiaryNetValue', 'assetsInfos.distribution.CNDAShareInEstimatedBeneficiaryNetValue', 'assetsInfos.distribution.beneficiaryShareInAssetLiabilities', 'assetsInfos.distribution.beneficiaryShareInLiberalityRecordActsFees',
    'beneficiary.name', 'zipCode', 'fullName', 'testator', 'testatorComment', 'object',
    'grossAssets', //'netAssets',
    'distribution.beneficiary.zipCode',
    'lifeInsuranceNetAmount', 'status.id', 'statusName'
]

export const module_ = {
    object: 'LiberalityRecordPresentation',
    name: 'Presentation',
    tKey: 'Présentation',
    objectIdentifier: 'applicationNumber',
    defaultFormButtons: [prepareListButton, returnButton],
    category: {
        path: 'menuTitle_liberalities',
        icon: 'testament'
    },
    viewMap: {
        dt: [
            {path: 'presentationDate', tKey: 'Présentation'},
            {path: 'filesNumber', tKey: 'Nb dossiers'},
            {path: 'updatedAt', tKey: 'Date'},
            {path: 'updatedBy', tKey: 'Utilisateur'},
            {path: 'table', tKey: 'Tableau'},
        ],
        form: {
            fields: [
                {path: 'presentationDate', tKey: 'Date de présentation', type: 'datePicker', startDate: moment().format('YYYY-MM-DD'), required: true, editable: false},
                {path: 'liberalityRecords', fieldPath: liberalityRecordPdfFields, display: 'fileApplicationNumberAndBenefactor', tKey: 'Dossiers', filters: ['readyTobePresented', 'notUsedInPresentation'], warnIfNotFound: false, required: true},
                {path: 'presentationDescription', tKey: 'Présentation', type: 'richTextEditor'},
                {path: 'reportDescription', tKey: 'Relevé de décisions', type: 'richTextEditor', disabled: true},
                {path: 'status', hidden :true},
                {path: 'buttons', hidden :true}
            ],
            onOpen: ({ store }) => {
                const state = store.getState()
                const objectMode = getObjectMode(state)
                const isNewObject = objectMode === 'newObject'

                if(isNewObject) {
                    store.dispatch(setFieldVisibility('e_reportDescription', false))
                    store.dispatch(setFieldVisibility('e_liberalityRecords', true))
                }
            }
        }
    },
    actionSubscriptions: [
        {
            actionType: GET_OBJECT_SUCCESS,
            subscription: ({ store }) => {
                const state = store.getState()
                const presentationStatus = state.edit.object.data.status
                const liberalityRecords = state.edit.object.data.liberalityRecords
                const presentationDate = state.edit.object.data.presentationDate
                const decisionWasMadeForAtLeastOneFile = liberalityRecords.some(file => ['validated', 'rejected', 'incomplete'].includes(file.status.id))

                store.dispatch(setFieldEdition('e_presentationDate', presentationStatus !== 'closed' && !decisionWasMadeForAtLeastOneFile))
                store.dispatch(setFieldVisibility('e_liberalityRecords', presentationStatus !== 'closed'))
                store.dispatch(setFieldEdition('e_liberalityRecords', moment(presentationDate).isSameOrAfter(moment(), 'day')))
                store.dispatch(setFieldVisibility('e_reportDescription', presentationStatus === 'closed'))
                store.dispatch(setFieldEdition('e_presentationDescription', presentationStatus !== 'closed'))
            }
        }
    ]
}
